var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Component 262 \\u2013 5",
    viewBox: "0 0 8.515 15.897"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4b4b4b",
    d: "m7.957 8.942.442-2.877H5.638V4.2A1.44 1.44 0 0 1 7.26 2.644h1.255V.194A15 15 0 0 0 6.291 0a3.513 3.513 0 0 0-3.76 3.873v2.192H0v2.877h2.528V15.9h3.11V8.942Z",
    "data-name": "Icon awesome-facebook-f"
  })));
};
export default SvgFacebook;